import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { ResourceState } from './resource.state';
import { ResourceStore } from './resource.store';

@Injectable({providedIn: 'root'})
export class ResourceQuery extends QueryEntity<ResourceState> {
  constructor(protected store: ResourceStore) {
    super(store);
  }
}
